import { useEffect, useState } from "react";
import { MenuItem } from "@mui/material";
import { t } from "i18next";
import ApiUrls from "../../helpers/urls/ApiUrls";
import api from "../../helpers/api/Api";
import SelectCustom from "../SelectCustom";
import "./domainSelect.css";

function SelectDomain({ value, onChange, error, owner, hasAll }) {
  const [domains, setDomains] = useState([]);
  const [domainsLoading, setDomainsLoading] = useState(true);
  const userType = JSON.parse(localStorage.getItem("user")).type;

  useEffect(() => {
    getDomainsList();
  }, [owner]);

  const getDomainsList = () => {
    let formData = {};
    if (owner && owner !== "all") {
      formData = new FormData();
      formData.append("userid", owner);
    }

    api.post(ApiUrls.domain.list, formData)
      .then((response) => {
        setDomainList(response.data.data);
      })
      .catch((error) => {
        setDomainsLoading(false);
      });
  }

  const setDomainList = (data) => {
    const domainsList = [];
    data.map((d) => {
      let name = d.name;
      if (name.charAt(name.length - 1) === " ") {
        name = name.substring(0, name.length - 1);
      }
      const domainArr = name.split(" ");
      let domainString = "";
      for (let i = 0; i < domainArr.length; i++) {
        domainString += domainArr[i];
        if (i === domainArr.length - 1) {
          break;
        }
        // show 2 domains of the domain list , if there is more add "..."
        if (i === 1) {
          if (i < domainArr.length - 1) {
            domainString += " ..."
          }
          break;
        }
        domainString += ", "
      }
      domainsList.push({ name: domainString, value: d.id });
    });

    setDomains(domainsList);
    setDomainsLoading(false);

    if(domainsList.length === 0) {
      onChange({ target: { value: "" } });
    }
  }

  return (
    <div className="domain-select">
      <SelectCustom
        id="domain-select"
        value={value}
        error={error}
        label={t("domain.domain")}
        onChange={onChange}
        loading={domainsLoading}
        disabled={!domainsLoading && domains.length === 0}
      >
        {!domainsLoading && domains.length === 0 &&
          <MenuItem value="" disabled>هیچ دامنه‌ای موجود نمی‌باشد</MenuItem>
        }
        {hasAll && userType === 0 && domains.length > 0 &&
           <MenuItem value="all" key="all-domains">{t("global.all")}</MenuItem>
        }
        {domains.map((domain, i) => {
          return (
            <MenuItem value={domain.value} key={i} className="domain-select">
              {domain.name}
            </MenuItem>
          )
        })}
      </SelectCustom>
    </div>
  );
}

export default SelectDomain;
